import {
  Checkbox as MantineCheckbox,
  CheckboxGroupProps as MantineCheckboxGroupProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './CheckboxGroup.module.css';

export type CheckboxGroupProps = Omit<
  MantineCheckboxGroupProps,
  'styles' | 'classNames' | 'style' | 'readOnly'
> & {
  isReadOnly?: boolean;
};

export const CheckboxGroup = forwardRef<HTMLDivElement, CheckboxGroupProps>(
  ({ children, isReadOnly, ...props }, ref) => {
    return (
      <MantineCheckbox.Group
        ref={ref}
        readOnly={isReadOnly}
        classNames={{
          root: isReadOnly ? styles.readOnly : undefined,
        }}
        {...props}
      >
        {children}
      </MantineCheckbox.Group>
    );
  }
);

CheckboxGroup.displayName = 'CheckboxGroup';
